import { Stack, Stepper } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import {
  CheckIcon,
  ExclamationTriangleIcon,
  MinusIcon,
  Pencil1Icon,
} from '@radix-ui/react-icons'

import { FeedbackWitnessForm } from './FeedbackWitnessForm'

import { AttendeeRole } from '@/constants'
import { Event, ReporterFeedback } from '@/types'

export type EventFeedbackFormProps = {
  activeWitnessIndex: number
  setActiveWitnessIndex: (activeWitnessIndex: number) => void
  form: UseFormReturnType<ReporterFeedback>
  event: Event
}

export const EventFeedbackForm = ({
  form,
  event,
  activeWitnessIndex,
  setActiveWitnessIndex,
}: EventFeedbackFormProps) => {
  if (form.values.events_feedbacks?.length === 1) {
    return (
      <Stack>
        <FeedbackWitnessForm form={form} witnessIndex={0} event={event} />
      </Stack>
    )
  }

  return (
    <Stepper
      active={activeWitnessIndex}
      onStepClick={setActiveWitnessIndex}
      iconSize={28}
      radius="sm"
      size="sm"
      completedIcon={<CheckIcon />}
    >
      {form.values.events_feedbacks?.map((witnessFeedbackData, index) => {
        const hasErrors = Object.keys(form.errors).some(errorKey =>
          errorKey.startsWith(`events_feedbacks.${index}`),
        )

        return (
          <Stepper.Step
            key={index}
            label={`Witness ${index + 1}`}
            description={
              witnessFeedbackData.attendees?.find(
                attendee => attendee.role === AttendeeRole.WITNESS,
              )?.name
            }
            completedIcon={
              hasErrors ? <ExclamationTriangleIcon /> : <CheckIcon />
            }
            icon={
              index === activeWitnessIndex ? <Pencil1Icon /> : <MinusIcon />
            }
            color={
              index <= activeWitnessIndex && !hasErrors ? undefined : 'red'
            }
          >
            <Stack>
              <FeedbackWitnessForm
                form={form}
                witnessIndex={index}
                event={event}
              />
            </Stack>
          </Stepper.Step>
        )
      })}
    </Stepper>
  )
}
